export const API_URL = "https://api.stashfin.com/Admin/services"; //live
// export const API_URL = "https://devapi.stashfin.com/Admin/services"; //Dev

// export const API_URL = "https://api.akaracap.com/Admin/services"; //Live
// export const API_URL = "https://uatapi.stashfin.com/Admin/services"; //dev
// export const API_URL = "http://192.168.43.54/docker/api-v1/app/Admin/services";//personal



// WEBPACK FOOTER //
// ./src/constants/Url.js